import React from 'react';
import { ElevatedButton } from '@producer/ui-kit';

import styles from './ErrorScreen.module.scss';

interface ErrorScreenProps {
  title: string;
  message: string;
  actionText: string;
  onActionClick: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title,
  message,
  actionText,
  onActionClick,
}) => (
  <div className={styles['error-screen-container']}>
    <h2 className={styles['error-screen-title']}>{title}</h2>

    <p className={styles['error-screen-message']}>{message}</p>

    {onActionClick ? <ElevatedButton text={actionText} onClick={onActionClick} /> : null}
  </div>
);
